import { plainDate } from "helpers/date";
import { isObject } from "helpers/system";
import moment from "moment";

export function composeValidators(validators: ((value: string, data: {}) => string)[] = [], value = "", data = {}) {
    return validators.map((item) => item(value, data)).filter((item) => Boolean(item && item.length))[0];
}
const phoneReg = /^\+7[0-9]{10}$/;
export const truckReg = /^[авекмнорстухАВЕКМНОРСТУХ]{1}[0-9]{3}[авекмнорстухАВЕКМНОРСТУХ]{2}\/[0-9]{2,3}$/;
export const trailerReg = /^[авекмнорстухАВЕКМНОРСТУХ]{2}[0-9]{4}\/[0-9]{2,3}$/;

export function requiredField(value: any) {
    if (!Array.isArray(value) && value && (value.value || value.value === 0)) {
        return "";
    } else if (typeof value === "number" && (value || value === 0)) {
        return "";
    } else if (typeof value === "boolean" && (value === true || value === false)) {
        return "";
    } else if (value instanceof Date) {
        return "";
    } else if (isObject(value) && Object.keys(value).length > 0) {
        return "";
    }
    return value && value.length ? "" : "Обязательное поле";
}

// export function minLength(value) {
//     return (value && value.length > 5) ? valid : { ...invalid, text: "Минимум 6 символов" };
// }

// export function typeNumber(value) {
//     const regexp = /^-?\d*(\.\d+)?$/;
//     return regexp.test(value) ? valid : { ...invalid, text: "Может быть только числом" };
// }

export function phoneNumber(value = "") {
    return phoneReg.test(value) ? "" : "Требуется формат +79999999999";
}

export function individualInn(value = "") {
    if (!/^\d{12}$/.test(value)) {
        return "Некорректная длина ИНН";
    }

    const digits = value.split("").map(Number);
    const checksum = (coefficients: number[]) =>
        (coefficients.reduce((sum, coefficient, index) => sum + coefficient * digits[index], 0) % 11) % 10;
    const penultimateDigit = checksum([7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
    const lastDigit = checksum([3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);

    return value !== "000000000000" && penultimateDigit === digits[10] && lastDigit === digits[11]
        ? ""
        : "Некорректный ИНН";
}

export function guid(value = "") {
    const guidRegExp = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return guidRegExp.test(value) ? "" : "Введите GUID в формате 00000000-0000-0000-0000-000000000000";
}

export function truckNumber(value = "") {
    return truckReg.test(value) ? "" : "Требуется формат А 111 АА / 111";
}

export function trailerNumber(value = "") {
    return trailerReg.test(value) ? "" : "Требуется формат АА 1111 / 111";
}

export function pastDate(value = "", data: { timeOffset?: string }) {
    const { timeOffset } = data;
    return (timeOffset && value ? moment(`${plainDate(value)}${timeOffset}`) : moment(value)) < moment()
        ? ""
        : "Дата должна быть в прошлом";
}

export function numberInRange(value = "", min: number, max: number) {
    const val = Number(value);
    return val >= min && val <= max ? "" : `Значение должно быть в промежутке от ${min} до ${max}`;
}

export function positiveInteger(value: string | number = "") {
    const val = Number(value);
    return Number.isInteger(val) && val > 0 ? "" : "Значение должно быть положительным целым числом";
}

export function optionalPositiveInteger(value: string | number = "") {
    return value || value === 0 ? positiveInteger(value) : "";
}

const documentNumberPrefixRegExp = /^[0-9A-Za-zА-Яа-яЁё]{2}$/u;
const nextDocumentNumberRegExp = /^[0-9]{1,6}$/;

export function documentNumberPrefix(value = "") {
    return documentNumberPrefixRegExp.test(value)
        ? ""
        : "Введите 2 символа: цифры или буквы русского/латинского алфавита";
}

export function nextDocumentNumber(value = "") {
    return nextDocumentNumberRegExp.test(value) ? "" : "Введите от 1 до 6 цифр";
}

export function timeToMinutes(value = "") {
    const [hours, minutes] = value.split(":").map(Number);

    if (Number.isNaN(hours) || Number.isNaN(minutes)) {
        return null;
    }

    return hours * 60 + minutes;
}

export function minTime(minValue: string, message?: string) {
    const minMinutes = timeToMinutes(minValue);

    return (value = "") => {
        if (!value) {
            return "";
        }

        const valueMinutes = timeToMinutes(value);

        if (valueMinutes === null || minMinutes === null || valueMinutes >= minMinutes) {
            return "";
        }

        return message || `Минимальное время ${minValue}`;
    };
}

export function validateLicenseExpirationDate(
    value: string | Date | moment.Moment = "",
    data?: {
        dateOfIssue?: string | Date | moment.Moment;
        licenseDateOfIssue?: string | Date | moment.Moment;
        [key: string]: unknown;
    },
): string {
    const issueDate = data?.dateOfIssue || data?.licenseDateOfIssue;
    if (!value || !issueDate) {
        return "";
    }

    if (moment(value).isBefore(moment(issueDate), "day")) {
        return "Дата истечения срока действия не может быть раньше даты выдачи";
    }

    return "";
}
